//
import Service from '@/services/api/Service'
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'

/**
 * This class describes a service.
 * @class      Service (name)
 */
export default class WhDispatchRequest extends Service {

  /**
   * Return the model resource of service.
   * @return     {Object}  The model resource
   */
  resource() {
    return DispatchRequestModel
  }

  /**
   * Returns a list representation of the service.
   * @return     {Object}  List representation of the service.
   */
  toList() {
    return this
      .include(
        'g_state', 
        'pos_sale.g_seller_user.hr_employee',
        'sl_customer', 
        'sl_sale_invoice', 
        'sl_sale_ticket'
      )
  }

  /**
   * Returns a list representation of the service.
   * @return     {Object}  List representation of the service.
   */
  toPendingList() {
    return this
      .include(
        'g_state', 
        'pos_sale.g_seller_user.hr_employee',
        'sl_customer', 
        'sl_customer_branch_offices.g_commune',
        'sl_sale_invoice', 
        'sl_sale_ticket',
      )
  }
}
